import React from 'react';
import { Typography, Box } from '@material-ui/core';

type Props = {
    errors?: Record<string, string>;
    instructionColor?: string;
    prefixText?: string;
};

const FormErrorInstruction: React.FC<Props> = ({
    errors = {},
    instructionColor = '#d32f2f', // MUI error.main like tone
    prefixText = 'Please complete:',
}) => {
    const errorList = Object.values(errors).filter(Boolean);

    if (!errorList.length) return null;

    const errorText = errorList.join(', ');

    return (
        <Box width="100%">
            <Typography
                variant="body2"
                style={{
                    color: instructionColor,
                    fontWeight: 500,
                }}
            >
                {prefixText} {errorText}
            </Typography>
        </Box>
    );
};

export default FormErrorInstruction;
